import { NextWorkingDayResponseV5 } from '@cemex-core/cmx-api/models/next-working-day/next-working-day-res';
import { CutOffTemperatureActions, CutOffTemperatureActionTypes } from '../actions/cut-off-temperature.actions';
import { OrderBuilderActions } from '../../../actions/order-builder.actions';

export interface CutOffTemperatureState {
  isTemperatureControl: boolean;
  formsWithTemperatureControl: {
    [formId: string]: boolean;
  };
  cutOff: NextWorkingDayResponseV5;
}

export const initialState: CutOffTemperatureState = {
  isTemperatureControl: false,
  formsWithTemperatureControl: {},
  cutOff: null,
};

export function cutOffReducer(
  state = initialState,
  action: CutOffTemperatureActions | OrderBuilderActions,
): CutOffTemperatureState {
  switch (action.type) {
    case CutOffTemperatureActionTypes.LOAD: {
      return {
        ...state,
        isTemperatureControl: true,
        formsWithTemperatureControl: { ...state.formsWithTemperatureControl, [action.formId]: true },
        cutOff: action.payload,
      } as CutOffTemperatureState;
    }
    case CutOffTemperatureActionTypes.CHANGE_FLAG_FORM: {
      const isAllFormsWithTemperatureControlFalse = Object.keys(state.formsWithTemperatureControl).every((formId) => {
        if (formId === action.formId.toString()) {
          return true;
        }
        return !state.formsWithTemperatureControl[formId];
      });
      if (isAllFormsWithTemperatureControlFalse) {
        return {
          ...initialState,
        };
      }
      return {
        ...state,
        formsWithTemperatureControl: { ...state.formsWithTemperatureControl, [action.formId]: false },
      } as CutOffTemperatureState;
    }
    case CutOffTemperatureActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
